var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartGantt"},_vm._l((_vm.result),function(res){return _c('div',{key:res.model},[_c('c-content-chart-gantt-view',{attrs:{"data":res,"redraw-trigger":_vm.redrawTrigger}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }